import Backbone from 'backbone';

let queryCount = 0;

export { requestBegins, requestEnds, beginLock, endLock, };

function requestBegins() {
    queryCount++;
    setTimeout( () => {
        if (queryCount > 0)
            Backbone.$( 'body' ).addClass( 'loader' );
    }, 200 );
}

function requestEnds() {
    setTimeout( () => {
        if (0 === --queryCount)
            Backbone.$( document.body ).removeClass( 'loader' );
    }, 50 );
}

const globalLockObject__ = { 
    $el: Backbone.$( document.body ),
    lockCount__: 0,
};

function beginLock(lockObject = globalLockObject__) {
    lockObject.lockCount__ = (lockObject.lockCount__ || 0) + 1;
    setTimeout( () => {
        if (lockObject.lockCount__ > 0)
            lockObject.$el.addClass( 'disabled' );
    }, 100 );
}

function endLock(lockObject = globalLockObject__) {
    setTimeout( () => {
        if (0 === (lockObject.lockCount__ = (lockObject.lockCount__ || 0) - 1))
            lockObject.$el.removeClass( 'disabled' );
    }, 50 );
}


// WEBPACK FOOTER //
// ./src/js/loader.js